export default "__VITE_ASSET__BrSYYpgb__"